import { Box } from "@chakra-ui/react";

import { css } from "@emotion/react";
import {
  Button,
  colors,
  customEvent,
  HackleEventName,
  HStack,
  LargeButton,
  LARGEL_BUTTON_TYPE,
  MQ,
  useResponsive,
  VStack,
} from "goi_common";
import { useRouter } from "next/router";

import ExplanationSection from "./components/Match/ExplanationSection";
import MatchHead from "./components/Match/MatchHead";
import MatchPRSection from "./components/Match/MatchPRSection";
import ReviewSection from "./components/Match/ReviewSection";
import TrustSection from "./components/Match/TrustSection";

export default function MatchContainer() {
  const router = useRouter();
  const { isBiggerThanLg, isBiggerThanMd } = useResponsive();

  return (
    <>
      <MatchHead />
      <ExplanationSection />
      <MatchPRSection />
      <VStack width="100%" alignItems="center" padding="60px 24px">
        <VStack width={isBiggerThanMd ? "380px" : "100%"} padding="0px 0px">
          <Button
            className={isBiggerThanLg ? "head2_b" : "button"}
            style={{
              width: "100%",
              height: isBiggerThanLg ? "80px" : "62px",
              background: colors.orange700,
              color: "white",
              borderRadius: "5px",
            }}
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "match",
                  trigger_and_target: "recommendation-uv_match_request",
                },
                hackle: { key: HackleEventName["견적 콘텐츠 - 상단 버튼 클릭"] },
              });
              router.push("/match/request/");
            }}
          >
            전문가 추천 받기
          </Button>
        </VStack>
      </VStack>
      <TrustSection />
      <ReviewSection />
      <VStack
        css={fixedWrapCss}
        background={colors.black}
        width="100%"
        height={isBiggerThanLg ? "80px" : "60px"}
        alignItems="center"
      >
        <HStack css={buttonWrapCss}>
          {isBiggerThanLg && (
            <div className="subtitle3 white">엄선된 장례전문가를 추천 받아보세요.</div>
          )}
          <Box css={buttonCss}>
            <LargeButton
              buttonType={isBiggerThanLg ? LARGEL_BUTTON_TYPE.ORANGE : LARGEL_BUTTON_TYPE.PRIMARY}
              height={60}
              borderRadius={0}
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "match",
                    trigger_and_target: "recommendation_fixed_button-uv_match_request",
                  },
                  hackle: { key: HackleEventName["견적 콘텐츠 - 고정 버튼 클릭"] },
                });
                router.push("/match/request/");
              }}
            >
              <Box display="flex" className="button">
                전문가 추천 받기
              </Box>
            </LargeButton>
          </Box>
        </HStack>
      </VStack>
    </>
  );
}

const fixedWrapCss = css({
  position: "fixed",
  width: "100%",
  height: "60px",
  bottom: "0",
  zIndex: 100,
  [MQ.lg]: {
    height: "80px",
    alignItems: "center",
    justifyContent: "center",
  },
});

const buttonWrapCss = css({
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  maxWidth: "1200px",

  [MQ.lg]: {
    justifyContent: "space-between",
    padding: "0px 24px",
  },
});

const buttonCss = css({
  width: "100%",

  maxWidth: "1200px",
  borderRadius: 0,
  overflow: "hidden",
  [MQ.lg]: {
    width: "160px",
    borderRadius: "5px",
  },
});

export const matchHeadFontCss = css({
  fontSize: "24px",
  fontWeight: 600,
  lineHeight: "32px",
  letterSpacing: "0px",

  [MQ.lg]: {
    fontSize: "42px",
    fontWeight: 700,
    lineHeight: "60px",
    letterSpacing: "-0.4px",
  },
});
